var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrevStepIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99797 6.00941C5.99836 6.20933 5.92865 6.40308 5.80093 6.55702L1.51743 11.6909C1.37202 11.8656 1.16306 11.9755 0.936524 11.9964C0.70999 12.0172 0.484437 11.9474 0.309485 11.8021C0.134532 11.6569 0.0245113 11.4482 0.00362514 11.2219C-0.017261 10.9957 0.0526984 10.7704 0.198113 10.5957L4.03613 6.00941L0.335186 1.42315C0.264023 1.33563 0.210881 1.23492 0.178813 1.12682C0.146745 1.01872 0.136385 0.905356 0.148326 0.793242C0.160268 0.681129 0.194276 0.572476 0.248397 0.473533C0.302518 0.374588 0.375685 0.287303 0.463691 0.216692C0.551778 0.138332 0.655119 0.0789862 0.767238 0.0423708C0.879357 0.00575542 0.99784 -0.00733852 1.11526 0.0039072C1.23268 0.0151529 1.34652 0.0504961 1.44963 0.107724C1.55273 0.164953 1.6429 0.242833 1.71447 0.336484L5.85233 5.47036C5.95986 5.62872 6.01114 5.81852 5.99797 6.00941Z",
    fill: "#AEAEAE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevStepIcon);
export default __webpack_public_path__ + "static/media/prevStepIcon.f81e9cce7b49ceb85f8704227fa03df3.svg";
export { ForwardRef as ReactComponent };